import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { SET_CURRENT_CITY, TSetCurrentCity } from '~/src/store/reducers/city';

export const setCurrentCity = (currentCity: ICurrentCity): TSetCurrentCity => ({
    type: SET_CURRENT_CITY,
    payload: {
        currentCity,
    },
});
